var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 6.73369C30.3527 3.64396 26.2431 1.94611 21.8755 1.94611C17.5019 1.94611 13.3982 3.64396 10.3085 6.73369C7.21875 9.82342 5.51489 13.9331 5.51489 18.3007C5.51489 27.1379 13.8722 34.4933 18.3658 38.441C18.9897 38.9929 19.5237 39.4669 19.9556 39.8628C20.4956 40.3668 21.1855 40.6188 21.8755 40.6188C22.5654 40.6188 23.2554 40.3668 23.7893 39.8628C24.2213 39.4669 24.7612 38.9929 25.3852 38.441C29.8728 34.4933 38.2301 27.1379 38.2301 18.3007C38.2301 13.9331 36.5322 9.82342 33.4425 6.73369V6.73369Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3033 27.272V28.7069C26.3033 28.8265 26.212 28.9461 26.0597 28.9461H17.7777C17.6559 28.9461 17.5341 28.8564 17.5341 28.7069V27.272C17.5341 27.1524 17.6255 27.0328 17.7777 27.0328H19.1784L20.0918 25.6577C20.5485 26.1359 21.2184 26.435 21.9491 26.435C22.6799 26.435 23.3194 26.136 23.8065 25.6577L24.7199 27.0328H26.0901C26.2119 27.0328 26.3032 27.1524 26.3032 27.272H26.3033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9187 23.0999C21.5273 23.0999 21.188 23.4132 21.188 23.8307C21.188 24.2222 21.5273 24.5615 21.9187 24.5615C22.3102 24.5615 22.6495 24.2222 22.6495 23.8307C22.6495 23.4132 22.3102 23.0999 21.9187 23.0999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9187 21.6384C20.7287 21.6384 19.7264 22.6094 19.7264 23.8307C19.7264 25.0521 20.6974 26.023 21.9187 26.023C23.1088 26.023 24.1111 25.0521 24.1111 23.8307C24.1111 22.6094 23.1089 21.6384 21.9187 21.6384ZM21.9187 25.1461C21.1671 25.1461 20.5721 24.551 20.5721 23.7994C20.5721 23.0478 21.1671 22.4528 21.9187 22.4528C22.6704 22.4528 23.2654 23.0478 23.2654 23.7994C23.2654 24.551 22.6704 25.1461 21.9187 25.1461Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3418 15.4269C14.337 15.4269 13.5149 16.249 13.5149 17.2538C13.5149 18.2586 14.337 19.0807 15.3418 19.0807C16.3466 19.0807 17.1687 18.2586 17.1687 17.2538C17.1687 16.249 16.3466 15.4269 15.3418 15.4269ZM15.3418 18.4108C14.7025 18.4108 14.1848 17.8931 14.1848 17.2538C14.1848 16.6145 14.7025 16.0968 15.3418 16.0968C15.9811 16.0968 16.4988 16.6145 16.4988 17.2538C16.4988 17.8933 15.9813 18.4108 15.3418 18.4108Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3418 16.523C14.9288 16.523 14.6111 16.8407 14.6111 17.2538C14.6111 17.6669 14.9287 17.9846 15.3418 17.9846C15.7549 17.9846 16.0726 17.6669 16.0726 17.2538C16.0726 16.8407 15.7549 16.523 15.3418 16.523Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.111 11.5904C24.111 11.8931 23.8657 12.1384 23.563 12.1384C23.2603 12.1384 23.0149 11.8931 23.0149 11.5904C23.0149 11.2876 23.2602 11.0423 23.563 11.0423C23.8657 11.0423 24.111 11.2876 24.111 11.5904Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7457 9.94611C22.9403 9.94611 22.2841 10.6024 22.2841 11.4076C22.2841 12.213 22.9404 12.8692 23.7457 12.8692C24.5511 12.8692 25.2072 12.2129 25.2072 11.4076C25.2072 10.6024 24.5509 9.94611 23.7457 9.94611ZM23.7457 12.3921C23.2087 12.3921 22.7911 11.9447 22.7911 11.4376C22.7911 10.9007 23.2385 10.4831 23.7457 10.4831C24.2528 10.4831 24.7002 10.9305 24.7002 11.4376C24.73 11.9447 24.2826 12.3921 23.7457 12.3921Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.188 21.2934C20.3593 21.5384 19.7305 22.2119 19.5019 23.0999L16.0726 19.4257C16.9298 19.242 17.5871 18.5378 17.7587 17.6192L21.188 21.2934Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0341 13.1206C26.3501 13.2032 25.8445 13.6981 25.785 14.3307L24.4764 13.1206C25.0415 12.8731 25.4876 12.378 25.5769 11.773L27.0341 13.1206Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0149 13.2543L17.6222 17.2538C17.5913 16.3145 16.9404 15.5268 16.0726 15.1935L21.806 11.0423C21.7751 11.1635 21.7441 11.315 21.7441 11.4665C21.744 12.2846 22.2709 12.9815 23.0146 13.2542L23.0149 13.2543Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7913 15.8427L28.0623 15.0854H28.0332C28.1207 14.9398 28.179 14.7651 28.179 14.5611C28.179 14.0368 27.7416 13.5999 27.2168 13.5999C26.6919 13.5999 26.2546 14.0368 26.2546 14.5611C26.2546 14.7649 26.3128 14.9398 26.4004 15.0854H26.3712L25.6423 15.8135C25.5841 15.8717 25.5548 15.93 25.5841 16.0173L25.9047 17.4445C25.9339 17.5319 26.0214 17.6192 26.1088 17.6192H26.167C26.2837 17.5901 26.3711 17.4736 26.342 17.357L26.0504 16.0463L26.6919 15.4054C26.6919 15.4054 26.6919 15.3764 26.721 15.3764C26.8668 15.4638 27.0417 15.522 27.2168 15.522C27.3917 15.522 27.5668 15.4638 27.7125 15.3764C27.7125 15.3764 27.7125 15.4054 27.7417 15.4054L28.3832 16.0463L28.0916 17.357C28.0625 17.4736 28.1499 17.5901 28.2665 17.6192H28.3248C28.4123 17.6192 28.5288 17.561 28.5288 17.4445L28.8495 16.0173C28.8788 15.9593 28.8497 15.9009 28.7913 15.8427Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3550",
    x: 0.0148926,
    y: 0.446106,
    width: 43.7152,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3550",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotArm);
export default __webpack_public_path__ + "static/media/robot-arm.61aac111829bb22ec3b2bc3dc61193b7.svg";
export { ForwardRef as ReactComponent };